import request from '../index'
import config from '../config'

/**
 * 图片上传
 * @param data
 */
export function upload(file) {
    const form = new FormData()
    form.append('file', file)
    form.append('input_name', 'file')
    return request({
        url: '',
        method: 'post',
        data: form,
        baseURL: config.UPLOAD_DOMAIN,
        noAuth: true,
        noChannel: true,
    })
}
